import { atom } from 'jotai';
import { atomWithStorage } from 'jotai/utils';
import type { Report } from '../lib/types';

export const reportsAtom = atom<Report[]>([]);

// Version history panel open state
export const versionPanelOpenAtom = atom<boolean>(false);

// Dashboard report-list filters — persisted to localStorage so the user's
// selection survives reloads and navigation. Empty string = no filter.
export const filterRegionAtom   = atomWithStorage('gm-filter-region',   '');
export const filterBranchAtom   = atomWithStorage('gm-filter-branch',   '');
export const filterDivisionAtom = atomWithStorage('gm-filter-division', '');
export const filterStatusAtom   = atomWithStorage('gm-filter-status',   '');
export const filterMonthAtom    = atomWithStorage('gm-filter-month',    '');
